@if (ps.isReady) {
  <div>
    <irb-common-banner #bannerComponent (update)="alertsUpdate()"></irb-common-banner>
    @if (enableCustomHomepage && isAccountsSet) {
      <div class="dashboard-modules-dimensions">
        <div class="dashboard-master-accounts-wrapper">
          <div class="dashboard-master-accounts-label">Master Accounts:</div>
          <irb-dropdown-search-multiple #masterAccountDropDown id="masterAccountDropDownId"
            [(values)]="masterAccounts" (search)="setMasterAccountDropDown($event)"
            width="180" hoverPanelWidth="180"
            [enableEmptySearchTerm]="true"
            showApplyButton="true" applyOnClear="true"
            (applySelection)="onMasterChange()"
            [showAsAll]="showAsAllForMADD">
          </irb-dropdown-search-multiple>
        </div>
        <irb-module-dynamic-builder [modulesToBuild]="modulesToBuild" [globalSettings]="globalSettings" (modulesToSave)="modulesToSave($event)"></irb-module-dynamic-builder>
      </div>
    }
    @if (!enableCustomHomepage) {
      <div class="p-grid" style="clear: both;">
        <div class="p-col-12 p-md-12 p-lg-4">
          <irb-com-clients></irb-com-clients>
        </div>
        <div class="p-col-12 p-md-12 p-lg-4">
          <irb-com-blotter></irb-com-blotter>
        </div>
        <div class="p-col-12 p-md-12 p-lg-4">
          <irb-com-cash-analysis></irb-com-cash-analysis>
        </div>
        <div class="p-col-12 p-md-12 " [class]="{'p-lg-8': !isShowAutoTrading, 'p-lg-4': isShowAutoTrading}">
          <irb-com-rebalancing></irb-com-rebalancing>
        </div>
        @if (isShowAutoTrading && globalSettings) {
          <div class="p-col-12 p-md-12 p-lg-4">
            <irb-com-auto-rebalancing-widget [globalSettings]="globalSettings"></irb-com-auto-rebalancing-widget>
          </div>
        }
        <div class="p-col-12 p-md-12 p-lg-4">
          <irb-com-allocation></irb-com-allocation>
        </div>
        <div class="p-col-12 p-md-12 p-lg-8" style="padding-bottom: 5px !important;">
          <irb-com-models></irb-com-models>
        </div>
        <div class="p-col-12 p-md-12 p-lg-4" style="padding-bottom: 5px !important;">
          <irb-com-mmc></irb-com-mmc>
        </div>
      </div>
    }
  </div>
}
